"use strict";

if (typeof window.Accordion === "undefined") {
  class Accordion {
    constructor(domNode) {
      this.rootEl = domNode;
      this.buttonEl = this.rootEl.querySelector("button[aria-expanded]");

      const controlsId = this.buttonEl.getAttribute("aria-controls");
      this.contentEl = document.getElementById(controlsId);

      this.isOpen = this.buttonEl.getAttribute("aria-expanded") === "true";
      this.enabled = true;

      this.buttonEl.addEventListener("click", this.onButtonClick.bind(this));

      // Set initial state: default to closed unless explicitly set to stay open
      const shouldStayOpen = this.rootEl.hasAttribute("data-initially-open");
      this.toggle(shouldStayOpen, false);
    }

    enable() {
      this.enabled = true;
      this.buttonEl.removeAttribute("disabled");
      this.rootEl.classList.remove("accordion--disabled");
      // Reset state to match current DOM state
      this.isOpen = this.buttonEl.getAttribute("aria-expanded") === "true";
    }

    disable() {
      this.enabled = false;
      this.buttonEl.setAttribute("disabled", "");
      this.rootEl.classList.add("accordion--disabled");
      // Show content when disabled
      this.contentEl.removeAttribute("hidden");
      this.buttonEl.setAttribute("aria-expanded", "true");
      // Clear any inline styles from jQuery animations
      this.contentEl.style.display = "";
    }

    isEnabled() {
      return this.enabled;
    }

    onButtonClick() {
      if (!this.isEnabled()) return;
      this.toggle(!this.isOpen);
    }

    toggle(open, animate = true) {
      if (!this.isEnabled() && !open) return;

      if (open === this.isOpen) {
        return;
      }

      this.isOpen = open;

      this.buttonEl.setAttribute("aria-expanded", `${open}`);

      const useAnimation = animate && typeof $ !== "undefined";

      if (open) {
        this.contentEl.removeAttribute("hidden");
        if (useAnimation) {
          // Add hide. Otherwise `hidden` attribute blocks animation
          $(this.contentEl).hide().slideDown();
        }
      } else {
        if (useAnimation) {
          $(this.contentEl).slideUp(() => {
            this.contentEl.setAttribute("hidden", "");
          });
        } else {
          this.contentEl.setAttribute("hidden", "");
        }
      }
    }

    // Add public open and close methods for convenience
    open() {
      this.toggle(true);
    }

    close() {
      this.toggle(false);
    }
  }

  // Export Accordion class to window for use in other scripts
  window.Accordion = Accordion;

  // Initialize accordions except those with data-manual-init
  document.addEventListener("DOMContentLoaded", function () {
    const accordions = document.querySelectorAll(
      ".a11y-accordion-item:not([data-manual-init])"
    );
    accordions.forEach((accordionEl) => {
      new Accordion(accordionEl);
    });
  });
}
